import classNames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';

interface BackgroundPosition {
  x?: string;
  y?: string;
}

interface BackgroundProps {
  image?: string;
  overlay?: boolean | string;
  position?: string | BackgroundPosition;
  video?: string[];
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

const Background = ({
  image,
  overlay,
  position,
  video,
  className,
  style,
}: BackgroundProps) => {
  const bgStyle: CSSProperties = {
    backgroundImage: image ? `url(${image})` : undefined,
    ...style,
  };

  if (typeof position === 'string') {
    bgStyle.backgroundPosition = position;
  } else if (typeof position === 'object' && position) {
    if (position.x) bgStyle.backgroundPositionX = position.x;
    if (position.y) bgStyle.backgroundPositionY = position.y;
  }

  return (
    <div
      className={classNames(
        'bg-holder',
        {
          overlay: overlay,
          [`overlay-${overlay}`]: typeof overlay === 'string',
        },
        className,
      )}
      style={bgStyle}
    >
      {video && (
        <video className="bg-video" autoPlay loop muted playsInline>
          {video.map((src, index) => (
            <source
              key={index}
              src={src}
              type={`video/${src.split('.').pop()}`}
            />
          ))}
        </video>
      )}
    </div>
  );
};

export default Background;
